import React from 'react'
import Carousel from '@components/carousel'
import BlogItem from '@components/blog-item'

const BlogSlider = ({ heading, description, blogList, sliderSettings }) => (
  <Carousel heading={heading} description={description} settings={{ ...sliderSettings, arrows: true }}>
    {blogList?.map((item, index) => (
      <BlogItem item={item} key={index} />
    ))}
  </Carousel>
)

export default BlogSlider